import { render, staticRenderFns } from "./ItemFornecedores.vue?vue&type=template&id=04bcbd78&"
import script from "./ItemFornecedores.vue?vue&type=script&lang=js&"
export * from "./ItemFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports